import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetProfession from './met-profession';
import MetProfessionDetail from './met-profession-detail';
import MetProfessionUpdate from './met-profession-update';
import MetProfessionDeleteDialog from './met-profession-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetProfessionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetProfessionUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetProfessionDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetProfession} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetProfessionDeleteDialog} />
  </>
);

export default Routes;
